<script setup lang="ts">
import {ref} from "vue";
import axios from "axios";
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";

import {useUserStore} from "@/store/user";
import {UserAPI} from "@/app/api/UserAPI";
import {useGuard} from "@this-dot/vue-route-guard";

const userStore = useUserStore()
const userAPI = new UserAPI()
const toast = useToast()
const auth = useGuard()
const { t } = useI18n()

const dialog = ref(false)
const loading = ref(false)
const code = ref("")
const timer = ref(0)

const setTimer = () => {
  timer.value = 60
  const interval = setInterval(() => {
    timer.value--
    if (timer.value <= 0) {
      clearInterval(interval)
    }
  }, 1000)
}

const sendCode = async () => {
  if (timer.value > 0) {
    dialog.value = true
    return
  }
  try {
    loading.value = true
    await userAPI.validateEmail(userStore.getUserId)
    code.value = ""
    setTimer()
    dialog.value = true
  } catch (error) {
    const msg = axios.isAxiosError(error) ? (error.response?.data?.msg || error) : error
    toast.error(t('emailValidation.sendFailed', { msg }))
  } finally {
    loading.value = false
  }
}
const validateCode = async () => {
  try {
    loading.value = true
    await userAPI.validateEmail(userStore.getUserId, code.value)
    toast.success(t('emailValidation.verifySuccess'))
    dialog.value = false
    await auth.refreshAuthentication()
  } catch (error) {
    const msg = axios.isAxiosError(error) ? (error.response?.data?.msg || error) : error
    toast.error(t('emailValidation.verifyFailed', { msg }))
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div v-if="!userStore.isEmailValidated">
    <v-row justify="center">
      <v-col cols="12" lg="6" md="8" sm="12">
        <v-alert color="warning" variant="tonal">
          {{ t('emailValidation.hint') }}
          <template v-slot:append>
            <v-btn variant="text" @click="sendCode" :loading="loading" :disabled="loading">{{ t('emailValidation.start') }}</v-btn>
          </template>
        </v-alert>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500">
      <v-card class="text-center">
        <v-card-title class="mt-4">{{ t('emailValidation.title') }}</v-card-title>
        <v-card-text>
          <p class="text-caption">{{ t('emailValidation.codeSentTo', { email: userStore.getEmail }) }}</p>
          <p class="text-caption">{{ t('emailValidation.enterCode') }}</p>
          <v-otp-input type="number" v-model="code" @finish="validateCode" />
          <v-btn class="mb-4" variant="text" @click="sendCode" :disabled="timer > 0 || loading" :loading="loading"> {{ timer > 0 ? timer + "s" : t('emailValidation.resend') }} </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

</style>
